module.exports = __webpack_public_path__ + "static/media/skyna.73c5e2f9.png";